import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import selectModal from 'store/modals/selectors';
import { MODAL_MANAGE_BULK_UPDATE } from 'store/modals/modals';
import {
  selectBulkUpdateCustomAttribute,
  selectModalBulkUpdateField,
  selectVulnsSelected,
  selectVulnWorkspace
} from 'store/ManageGeneral/selectors';
import { selectWorkspaces } from 'store/Faraday/selectors';
import { setBulkUpdateField, setBulkUpdateValue } from 'store/ManageGeneral/actions';
import get from 'lodash/get';
import BulkTitle from './components/BulkTitle';
import SubmitButtons from './components/SubmitButtons';
import { ModalContent, Wrapper, EditorWrapper } from './styled';
import BULK_UPDATE_COMPONENTS from './components/components';
import {
  BulkDescription,
  NameGroupingWarning
} from 'Screens/Contextualization/Manage/components/ManageTable/components/BulkUpdateModal/styled';
import { useIntl } from 'react-intl';
import { isWorkspaceGroupedByName } from 'Common/Functions/vulnerabilityNameEdit';

const BulkUpdateModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const showModal = useSelector((state) => selectModal(state, MODAL_MANAGE_BULK_UPDATE));
  const vulnsSelected = useSelector(selectVulnsSelected);
  const selectedVulnsCount = vulnsSelected.length;
  const customAttribute = useSelector(selectBulkUpdateCustomAttribute);
  const vulnWorkspace = useSelector(selectVulnWorkspace);
  const workspaces = useSelector(selectWorkspaces);
  const field = bulkUpdateField === 'custom_fields' ? get(customAttribute, 'field_type', '') : bulkUpdateField;
  const bulkUpdateComponent = get(BULK_UPDATE_COMPONENTS, field, null);
  const showSubmitButtons = bulkUpdateField !== 'comment';
  const selectedWorkspaceNames = vulnsSelected.map((vuln) => get(vuln, 'workspace_name', ''));
  const workspaceNamesToCheck = selectedWorkspaceNames.length > 0 ? selectedWorkspaceNames : [vulnWorkspace];
  const showNameGroupingWarning = bulkUpdateField === 'name' && workspaceNamesToCheck.some((workspaceName) => (
    isWorkspaceGroupedByName(workspaceName, workspaces)
  ));

  useEffect(() => () => {
    dispatch(setBulkUpdateValue(''));
    dispatch(setBulkUpdateField(''));
  }, [dispatch]);

  if (!showModal) return null;
  return (
    <Wrapper>
      <ModalContent>
        <BulkTitle />
        {showNameGroupingWarning && (
          <NameGroupingWarning>
            This vulnerability belongs to a workspace where “Group by Similarity Name” is enabled.
            {' '}
            Renaming it may trigger automatic regrouping with similar vulnerabilities.
          </NameGroupingWarning>
        )}
        { selectedVulnsCount > 1 && <BulkDescription>{ intl.formatMessage({ id: 'vulns.edit.description' }) }</BulkDescription> }
        <EditorWrapper isBulk={ selectedVulnsCount > 1 }>
          { bulkUpdateComponent }
        </EditorWrapper>
        { showSubmitButtons && <SubmitButtons /> }
      </ModalContent>
    </Wrapper>
  );
};

export default BulkUpdateModal;
